import { BiQueryResult } from '@euler/model/bi/result';
import { BiVizSpec } from '@euler/model/bi/viz';
import { memo } from 'react';
import { EditorSection } from '../EditorSection';
import {
  biEditorFormatTargets,
  biEditorWithFormat,
} from '../functions/biEditorFormats';
import { BiEditorState } from '../functions/biEditorState';
import { FormatColumnRow } from './FormatColumnRow';

/**
 * 数字格式: per measure the card shows, how its numbers read — only the
 * kinds and options that fit the column. Built from the live preview.
 */
export const FormatSection = memo(
  ({
    state,
    viz,
    result,
    onChange,
  }: {
    state: BiEditorState;
    viz: BiVizSpec | null;
    result: BiQueryResult | null;
    onChange: (update: (current: BiEditorState) => BiEditorState) => void;
  }) => {
    const targets = viz ? biEditorFormatTargets(state, result) : [];
    if (!targets.length) return null;
    return (
      <EditorSection title="数字格式" note="不设置时按数据本身的格式显示">
        {targets.map(target => (
          <FormatColumnRow
            key={target.key}
            target={target}
            onChange={format =>
              onChange(current =>
                biEditorWithFormat(current, target.key, format, target.base),
              )
            }
          />
        ))}
      </EditorSection>
    );
  },
);
